/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type CreateGooseGameQuestMutationVariables = Types.Exact<{
  eventId: Types.Scalars["Float"];
  title: Types.Scalars["String"];
  type: Types.GooseGameQuestType;
  pointsRewarded: Types.Scalars["Float"];
  completionLimit: Types.Scalars["Float"];
  questEventActivityCategory?: Types.Maybe<Types.Scalars["String"]>;
  description?: Types.Maybe<Types.Scalars["String"]>;
  questionString?: Types.Maybe<Types.Scalars["String"]>;
  questionAnswer?: Types.Maybe<Types.Scalars["String"]>;
  flash?: Types.Maybe<Types.Scalars["Boolean"]>;
  hidden?: Types.Maybe<Types.Scalars["Boolean"]>;
  meta?: Types.Maybe<Types.Scalars["JSON"]>;
}>;

export type CreateGooseGameQuestMutation = {
  createGooseGameQuest: Pick<
    Types.GooseGameQuest,
    "id" | "title" | "flash" | "hidden"
  >;
};

export const CreateGooseGameQuestDocument = gql`
  mutation CreateGooseGameQuest(
    $eventId: Float!
    $title: String!
    $type: GooseGameQuestType!
    $pointsRewarded: Float!
    $completionLimit: Float!
    $questEventActivityCategory: String
    $description: String
    $questionString: String
    $questionAnswer: String
    $flash: Boolean
    $hidden: Boolean
    $meta: JSON
  ) {
    createGooseGameQuest(
      event_id: $eventId
      title: $title
      type: $type
      points_rewarded: $pointsRewarded
      completion_limit: $completionLimit
      quest_event_activity_category: $questEventActivityCategory
      description: $description
      question_string: $questionString
      question_answer: $questionAnswer
      flash: $flash
      hidden: $hidden
      meta: $meta
    ) {
      id
      title
      flash
      hidden
    }
  }
`;

/**
 * __useCreateGooseGameQuestMutation__
 *
 * To run a mutation, you first call `useCreateGooseGameQuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGooseGameQuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGooseGameQuestMutation, { data, loading, error }] = useCreateGooseGameQuestMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      pointsRewarded: // value for 'pointsRewarded'
 *      completionLimit: // value for 'completionLimit'
 *      questEventActivityCategory: // value for 'questEventActivityCategory'
 *      description: // value for 'description'
 *      questionString: // value for 'questionString'
 *      questionAnswer: // value for 'questionAnswer'
 *      flash: // value for 'flash'
 *      hidden: // value for 'hidden'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useCreateGooseGameQuestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateGooseGameQuestMutation,
    CreateGooseGameQuestMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CreateGooseGameQuestMutation,
    CreateGooseGameQuestMutationVariables
  >(CreateGooseGameQuestDocument, baseOptions);
}
export type CreateGooseGameQuestMutationHookResult = ReturnType<
  typeof useCreateGooseGameQuestMutation
>;
export type CreateGooseGameQuestMutationResult =
  ApolloReactCommon.MutationResult<CreateGooseGameQuestMutation>;
export type CreateGooseGameQuestMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateGooseGameQuestMutation,
    CreateGooseGameQuestMutationVariables
  >;
